export const LIGHT_COLOR = "#fff";
export const BLACK_COLOR = "#0e0e0e";
export const BLACK_MUTE_COLOR = "#292d32";
export const ALERT_COLOR = "#ff0230";
export const WARNING_COLOR = "#e74013";
export const SATURATED_HALF_GREEN = "rgb(50,141,72)";
export const GREEN_COLOR = "#19b500";
export const BRAND_COLOR = "#00c771";
export const BRAND_LIGHT = "#e5f9f0";
export const BRAND_HIGHLIGHTED = "#6bab90";
export const BRAND_SATURATED = "#00653a";
export const BRAND_TEXT_PRIMARY = "#003e23";
export const BRAND_TEXT_SECONDARY = "#025431";
export const LOGO_GRAY = "#696969";
export const GRAY_COLOR = "#8c8c8c";
export const LIGHT_GRAY = "#ededed";
